module.exports = __webpack_public_path__ + "img/eyebrow_male_straight_thick_mask.6204c63e.png";